@if (components) {
  <div class="free-content-cgv-page">
    @for (component of components; track component) {
      <ng-template [cxOutlet]="component.flexType" [cxOutletContext]="{ component: component }">
        <ng-container [cxComponentWrapper]="component" />
      </ng-template>
    }
  </div>
}
